import { FULFILLMENT } from '../../constants';
import { fulfillmentDeliveryActions } from '@detox/actions';

const REQUEST_STATUS = FULFILLMENT.REQUEST_STATUS;

const initialState = {
  status: REQUEST_STATUS.IDLE,
  data: {},
  isLoading: false
};
const {
  GET_STORE_AVAILABILITY_ERROR,
  GET_STORE_AVAILABILITY_SUCCESS,
  GET_STORE_AVAILABILITY_LOADING
} = fulfillmentDeliveryActions.STORE_AVAILABILITY_ACTIONS;
export const storeStockReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case GET_STORE_AVAILABILITY_LOADING: {
      return {
        ...state,
        status: REQUEST_STATUS.PENDING,
        hasError: false,
        errorCode: undefined,
        isLoading: true
      };
    }
    case GET_STORE_AVAILABILITY_SUCCESS: {
      return {
        ...state,
        data: actions.payload,
        status: REQUEST_STATUS.SUCCEEDED,
        isLoading: false
      };
    }
    case GET_STORE_AVAILABILITY_ERROR: {
      return {
        ...state,
        status: REQUEST_STATUS.FAILED,
        hasError: true,
        errorCode: actions.payload,
        data: {},
        isLoading: false
      };
    }

    default: {
      return state;
    }
  }
};
